import Vue from 'vue';

Vue.filter('numberToDollar', value => {
    return (value / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
});